// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2gJNg","content":"styles_content__3Q3GY","selectAll":"styles_selectAll__2ZJ1B"};